import _ from 'lodash';
import { initializeApp } from 'firebase/app';
import {
    getFirestore, doc, setDoc, updateDoc, getDoc, getDocs, collection, addDoc, deleteDoc, query, orderBy, where,
} from 'firebase/firestore';
import moment from 'moment';
import { statementTypes } from '@/assets/commonData/options';

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592
const firebaseConfig = {
    apiKey: 'AIzaSyA-j8mROJvU_VudDq5gK_j2tHOOx8PqYps',
    authDomain: 'sokuji-variable-editor.firebaseapp.com',
    projectId: 'sokuji-variable-editor',
    storageBucket: 'sokuji-variable-editor.appspot.com',
    messagingSenderId: '817931883707',
    appId: '1:817931883707:web:b9a30be075fde2e66d859e',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default class {
    constructor() {
        // Initialize Cloud Firestore and get a reference to the service
        this.db = getFirestore(app);
        this.userSno = null;
    }

    init(userSno, userName) {
        this.userSno = userSno;
        this.userName = userName;
        // this.registerDataListener();
    }

    async updateSample(sampleName, data) {
        const { cInElseSettings } = data;
        const { cInSettings } = data;
        const { cOutElseSettings } = data;
        const { cOutSettings } = data;
        const { invoiceSettings } = data;
        const { payoutSettings } = data;

        await setDoc(doc(this.db, 'Editor', sampleName), {
            name: data.name,
            isDraft: data.isDraft,
            createdTime: data.createdTime,
            lastUpdateTime: +moment().format('x'),
            cInElseSettings,
            cInSettings,
            cOutElseSettings,
            cOutSettings,
            invoiceSettings,
            payoutSettings,
        });
    }

    addSample(sampleName, data) {
        const { cInElseSettings } = data;
        const { cInSettings } = data;
        const { cOutElseSettings } = data;
        const { cOutSettings } = data;
        const { invoiceSettings } = data;
        const { payoutSettings } = data;

        return addDoc(collection(this.db, 'Editor'), {
            name: sampleName,
            isDraft: true,
            createdTime: +moment().format('x'),
            lastUpdateTime: +moment().format('x'),
            cInElseSettings,
            cInSettings,
            cOutElseSettings,
            cOutSettings,
            invoiceSettings,
            payoutSettings,
        });
    }

    async deleteSample(sampleName) {
        await deleteDoc(doc(this.db, 'Editor', sampleName));
    }

    async getSample(sampleName) {
        const docRef = doc(this.db, 'Editor', sampleName);
        const docSnap = await getDoc(docRef);

        console.log(docSnap);

        return docSnap.data();
    }

    async getList() {
        const idList = [];
        const dataList = {};

        const q = query(collection(this.db, 'Editor'), orderBy('isDraft', 'desc'), orderBy('createdTime', 'desc'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((o) => {
            const DATA = o.data();
            idList.push({ id: o.id, label: `${DATA.name}${DATA.isDraft ? '（草稿）' : ''}` });
            dataList[o.id] = DATA;
        });
        idList.reverse();

        return { idList, dataList };
    }

    async toggleDeployment(name, isDraft) {
        const ref = doc(this.db, 'Editor', name);
        await updateDoc(ref, { isDraft, lastUpdateTime: +moment().format('x') });
    }

    async getListImportFormat() {
        const idList = [];
        const dataList = {};

        const q = query(collection(this.db, 'Editor'), where('isDraft', '==', false), orderBy('createdTime', 'asc'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((o) => {
            const DATA = o.data();
            idList.push({ id: o.id, label: DATA.name });
            dataList[o.id] = DATA;
        });
        idList.reverse();

        const RETURN_DATA_LIST = {};
        _.forEach(dataList, (sampleData, sampleKey) => {
            const DATA = [];
            _.forEach(sampleData, (value, key) => {
                if (key === 'cInElseSettings' || key === 'payoutSettings' || key === 'cOutElseSettings' || key === 'cInSettings' || key === 'invoiceSettings' || key === 'cOutSettings') {
                    DATA.push({
                        type: _.find(statementTypes, ['key', key]).type,
                        iteM_NAM: _.find(statementTypes, ['key', key]).value,
                        key,
                        children: _.map(value, (i) => ({
                            grP_AMT: i.grP_AMT,
                            iteM_NAM: i.iteM_NAM,
                            isshare: i.isshare,
                            grP_NAM: i.grP_NAM,
                            grP_MEM: i.grP_MEM,
                            type: _.find(statementTypes, ['key', key]).type,
                            children: _.map(i.childSettings, (j) => ({
                                ...j,
                                key,
                                parentName: i.iteM_NAM,
                            })),
                        })),
                    });
                }
            });
            const SORTED = [];
            statementTypes.forEach(({ key }) => {
                const FOUND = _.find(DATA, ['key', key]);
                SORTED.push(FOUND);
            });

            RETURN_DATA_LIST[sampleKey] = SORTED;
        });

        return { idList, dataList: RETURN_DATA_LIST };
    }
}
